import React from "react";

const GenericError = () => (
  <div className="generic-error">
    <p>Oops! We're having issues.</p>
    <p>Please try again later.</p>
  </div>
);

export default GenericError;
